(function(){
    'use strict';

    var paginatorSelect = {
        templateUrl: 'app/components/paginator/paginator-select.html',
        controller: paginationSelectController,
        controllerAs: 'vm'
    };

    var paginator = {
        templateUrl: 'app/components/paginator/paginator.html',
        controller: paginatorController,
        controllerAs: 'vm',
        bindings:{
            pages: '='
        }
    };

    angular
        .module('completeAir')
        .component('paginatorSelect', paginatorSelect)
        .component('paginator', paginator);

    paginatorController.$inject = ['$state', '$stateParams', 'linkService'];
    paginationSelectController.$inject = ['$state', '$stateParams', 'linkService'];

    function paginatorController($state, $stateParams, linkService){
        var vm = this;
        vm.navButtons = [];

        vm.$onInit = function () {
            if (!vm.pages.totalPages) {
              vm.pages = {
                number: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0
              };
            }
            vm.state = $state;
            vm.stateParams = $stateParams;
            vm.disablePagePrevious = ($stateParams.page == 0) ? true : false;
            vm.disablePageNext = ($stateParams.page == (vm.pages.totalPages - 1)) ? true : false;

            vm.pageSize = {
                "id": vm.stateParams.size,
                "name": vm.stateParams.size
            };

            vm.selectSizeOption = [{
                "id": 10,
                "name": 10
            }, {
                "id": 25,
                "name": 25
            }, {
                "id": 50,
                "name": 50
            }, {
                "id": 100,
                "name": 100
            }];

            vm.pagesArray = (vm.pages) ? vm.pages : [];

            vm.breadCrumbsPre = 0;
            vm.breadCrumbsPost = 0;

            vm.totalPages = vm.pages;

            vm.actualPage = vm.stateParams.page;

            for (var i = 0; i < vm.totalPages.totalPages; i++) {
                vm.navButtons.push({
                    "size": vm.totalPages.size,
                    "number": i,
                    "hideItem": hideItem(i)
                })
            }

            vm.fromPage = (parseInt(vm.actualPage) *(typeof vm.pageSize.name === 'undefined' ? $stateParams.size : vm.pageSize.name )) + 1;
            vm.toPage = (vm.fromPage +  (vm.pagesArray.size - 1));
            vm.totalElements = vm.totalPages.totalElements;
        }

        vm.setSizeSelected = function (size, page, option) {
            if (page % 1 === 0) {
                linkService.reloadRoute($state.current, {
                    size: size + "",
                    page: page + ""
                });
            }
        };

        vm.isNumeric = function (index) {
            if (index % 1 === 0) {
                return index + 1;
            } else {
                return index;
            }
        };

        function hideItem(position) {
            if (( position <= (parseInt(vm.actualPage) - 3)) || ( position >= (parseInt(vm.actualPage) + 3))) {
                return 0
            } else {
                return 1
            }
        }

        addBreadCrumbs();

        function addBreadCrumbs() {
            if (((vm.actualPage >= 3) && vm.navButtons.length > 5)) {
                vm.breadCrumbsPre = 1;
            }
            if ((vm.navButtons.length - 3) > vm.actualPage) {
                vm.breadCrumbsPost = 1;
            }
        }

        vm.handleNextPrev = function (np) {
            if (np == 1 && (parseInt(vm.actualPage)) > 0) {
                linkService.reloadRoute(vm.state.current.name, {
                    size: vm.pageSize.name,
                    page: parseInt(vm.actualPage) - 1
                })
            } else if (np == 2 && (parseInt(vm.actualPage) + 1) < vm.totalPages.totalPages) {
                linkService.reloadRoute( vm.state.current.name, {
                    size: vm.pageSize.name,
                    page: parseInt(vm.actualPage) + 1
                })
            }
        }
    }

    function  paginationSelectController($state, $stateParams, linkService) {
        var vm = this;

        vm.$onInit = function () {
            vm.state = $state;
            vm.stateParams = $stateParams;

            vm.pageSize = {
                "id": vm.stateParams.size,
                "name": vm.stateParams.size
            };

            vm.selectSizeOption = [{
                "id": 10,
                "name": 10
            }, {
                "id": 25,
                "name": 25
            }, {
                "id": 50,
                "name": 50
            }, {
                "id": 100,
                "name": 100
            }];
        }

        vm.setSizeSelected = function (size, page, option) {
            if (page % 1 === 0) {
                linkService.reloadRoute( vm.state.current.name, {
                    size: size + "",
                    page: page + ""
                });
            }
        };
    }
})();

